export default __webpack_public_path__ + "static/media/blog-3a.46d35002.jpg";